import React from "react"
import PropTypes from "prop-types"
import "./UsersGroupedByRole.scss"

export default class UsersGroupedByRole extends React.PureComponent {
  render() {
    const groupedByRole = this.props.users.reduce((grouped, user) => {
      if (user.userHealthcareRoleType !== "unknown") {
        if (!grouped[user.userHealthcareRoleType])
          grouped[user.userHealthcareRoleType] = new Set()
        grouped[user.userHealthcareRoleType].add(user.userName)
      }
      return grouped
    }, {})

    return (
      <div className="UsersGroupedByRole">
        {this.props.headerContent && (
          <div className="header">{this.props.headerContent}</div>
        )}
        {Object.keys(groupedByRole)
          .sort()
          .map(role => (
            <div key={role} className="users">
              <div className="user-group">
                <div className="role">
                  {role === "primary" ? "Nurse" : "Nurse Assistant"}
                </div>
                {[...groupedByRole[role]].map(name => (
                  <div key={name} className="name">
                    {name}
                  </div>
                ))}
              </div>
            </div>
          ))}
      </div>
    )
  }
}

UsersGroupedByRole.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      userName: PropTypes.string.isRequired,
      userHealthcareRoleName: PropTypes.string.isRequired,
      userHealthcareRoleType: PropTypes.string.isRequired,
    })
  ).isRequired,
  headerContent: PropTypes.node,
}
